import {
    FETCHED_USER,
    UPDATED_USER
} from './types';

export function fetchedUser(user) {
    return {
        type: FETCHED_USER,
        user
    };
}

export function updatedUser(user) {
    return {
        type: UPDATED_USER,
        user
    }
}



// WEBPACK FOOTER //
// ./src/containers/myaccount/actions.js